<template>
    <div class="section-dept-node">
         <MemberNode 
            v-if="data.type === 0"
            :data="data"
            @handleChecked="handleChecked" />
        <TreeNode 
            v-else
            @handleExpand="handleExpand"
            @handleChecked="handleChecked"
            :showExpand="showExpand"
            :showExpandIcon="withMembers ? !!data.userNum : !!data.haveSub"
            :showChecked="!withMembers"
            :showIndeterminate="!!withMembers && !!data.userNum"
            :loading="data.loading"
            :expand="data.expand"
            :indeterminate="data.indeterminate"
            :checked="checked">
            <template slot="content">
                {{data.deptName}}
            </template>
            <span slot="operate" class="section-dept-node-contain" 
                v-if="root.enableContainChild && !withMembers && data.haveSub" 
                @click="getDeptChildList(data.deptId, data)">
                <span>{{data.contain ? t('selectMember.cancelSubordinate') : t('selectMember.includingSubordinate')}}</span>
            </span>
            <div 
                class="section-dept-children"
                slot="children" 
                v-if="data.children">
                <div :class="{
                        'section-dept-children-item': item.type === 1,
                        'section-dept-children-item-member': item.type === 0,
                    }" 
                    v-for="(item, index) in data.children" :key="index">
                    <DeptNode 
                        v-if="item.type === 1"
                        :data="item"
                        :withMembers="withMembers"
                        @handleExpand="handleExpand"
                        @handleChecked="handleChecked"
                        @getDeptChildList="getDeptChildList" />
                    <MemberNode 
                        v-if="item.type === 0"
                        :data="item"
                        @handleChecked="handleChecked" />
                </div>
            </div>
        </TreeNode>
    </div>
</template>
<script>
    /**
     * 组织节点
     *  */
    import MemberNode from './section-member-node'
    import node from '../mixins/node'
    import Locale from '../../../../mixins/locale'
    export default {
        name: 'DeptNode',
        inject: ['root'],
        mixins: [node, Locale],
        props: {
            data: {
                type: Object,
                default () {
                    return {}
                }
            },
            withMembers: {
                type: Boolean
            },
            showExpand: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                contain: false
            }
        },
        components: {
            MemberNode,
        },
        computed: {
            checked() {
                const data = this.root.selected.dept[this.data.deptId] || null
                return !!data
            },
            indeterminate() {
                return this.data.indeterminate
            }
        },
        methods: {
            getDeptChildList(deptId, params) {
                this.$emit('getDeptChildList', deptId, params)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/business/select-member/section/section-dept-node.vue